export const TYPE = [
   {
      id: 0,
      name: 'Node',
      code: '',
   },
   {
      id: 1,
      name: 'Sales Enquiry',
      code: 'S',
   },
   {
      id: 2,
      name: 'Sales Quote',
      code: 'S',
   },
   {
      id: 3,
      name: 'Sales Order',
      code: 'S',
   },
   {
      id: 4,
      name: 'Sales Challan',
      code: 'S',
   },
   {
      id: 5,
      name: 'Sales Invoice', // add
      code: 'S',
   },
   {
      id: 6,
      name: 'Sales Return',
      code: 'P',
   },
   {
      id: 7,
      name: 'Purchase Enquiry',
      code: 'P',
   },
   {
      id: 8,
      name: 'Purchase Quote',
      code: 'P',
   },
   {
      id: 9,
      name: 'Purchase Order',
      code: 'P',
   },
   {
      id: 10,
      name: 'Purchase Challan',
      code: 'P',
   },
   {
      id: 11,
      name: 'Purchase Invoice', // add
      code: 'P',
   },
   {
      id: 12,
      name: 'Purchase Return',
      code: 'S',
   },
   {
      id: 13,
      name: 'Cash', // add
      code: 'M',
   },
   {
      id: 14,
      name: 'Bank', // add
      code: 'N',
   },
   // {
   //    id: 15,
   //    name: 'Petty Cash',
   //    code: 'M',
   // },
   {
      id: 16,
      name: 'Debit Note',
      code: '',
   },
   {
      id: 17,
      name: 'Credit Note',
      code: '',
   },
   {
      id: 18,
      name: 'Journal Voucher',
      code: '',
   },
   {
      id: 19,
      name: 'Inventory Issue',
      code: '',
   },
   {
      id: 20,
      name: 'Inventory Receipt',
      code: '',
   },
   // {
   //    id: 21,
   //    name: 'Other Book',
   //    code: '',
   // },
];

export const SUB_TYPE = [
   {
      id: 0,
      // id: 'Normal',
      name: 'Normal',
   },
   {
      id: 1,
      // id: 'Gray Receipt',
      name: 'Gray Receipt',
   },
   {
      id: 2,
      // id: 'Reprocess',
      name: 'Reprocess',
   },
   {
      id: 3,
      // id: 'Job Work',
      name: 'Job Work',
   },
];

// methodOfRoundLI
export const METHOD_OF_ROUND_LI_TYPE = [
   {
      id: 0,
      // id: 'Truncate',
      name: 'Truncate',
   },
   {
      id: 1,
      // id: 'None',
      name: 'None',
   },
   {
      id: 2,
      // id: 'Normal',
      name: 'Normal',
   },
   {
      id: 3,
      // id: 'Plus',
      name: 'Plus',
   },
   {
      id: 4,
      // id: 'Minus',
      name: 'Minus',
   },
];

// AUTO ROUND OFF AT
export const AUTO_ROUND_OFF_AT_TYPE = [
   {
      id: 0,
      // id: 'None',
      name: 'None',
   },
   {
      id: 1,
      // id: 'Line-Item',
      name: 'Line-Item',
   },
   {
      id: 2,
      // id: 'Total',
      name: 'Total',
   },
   {
      id: 3,
      // id: 'Both',
      name: 'Both',
   },
];

// issueFieldRegion
export const REGION_TYPE = [
   {
      id: 0,
      name: 'Header Panel',
   },
   {
      id: 1,
      name: 'Header',
   },
   {
      id: 2,
      name: 'Line-item',
   },
   {
      id: 3,
      name: 'Line-item Born',
   },
   {
      id: 4,
      name: 'Line Detail',
   },
   {
      id: 5,
      name: 'Terms',
   },
   {
      id: 6,
      name: 'Terms Column',
   },
   {
      id: 7,
      name: 'Footer',
   },
];

// printingSettings
export const PRINTING_SETTING_TYPE = [
   {
      id: 0,
      name: 'Default',
   },
   {
      id: 1,
      name: 'Manual Format',
   },
];
